export const tokensToMigrate = ["nep141:aurora"]
